/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ValidateService {
  constructor() {}

  validateISBNValues(isbnListData): boolean {
    let isIsbnInValid = false;
    if (isbnListData == "" || isbnListData == undefined) {
      isIsbnInValid = true;
      return;
    }
    if (isbnListData != "" && isbnListData.trim().length) {
      let isbnArray = isbnListData.split(",");

      if (isbnArray.length > 1) {
        for (let i = 0; i < isbnArray.length; i++) {
          if (isbnArray[i].trim().length !== 13) {
            isIsbnInValid = true;
            break;
          }
        }
      } else if (isbnArray[0].trim().length != 13) {
        isIsbnInValid = true;
      }
    } else {
      isIsbnInValid = true;
    }

    return isIsbnInValid;
  }
}
